export type WorkspaceRoute = {
  userKey: string;
  screenKey: string | null;
};

export const workspacePath = (publicId: string) =>
  `/u/${encodeURIComponent(publicId)}/screens`;

export const screenPath = (publicId: string, screenCode: string) =>
  `${workspacePath(publicId)}/${encodeURIComponent(screenCode)}`;

export const parseWorkspacePath = (pathname: string): WorkspaceRoute | null => {
  const match = pathname.match(
    /^\/(?:u|users)\/([^/]+)\/screens(?:\/([^/]+))?\/?$/,
  );
  if (!match) {
    return null;
  }
  try {
    return {
      userKey: decodeURIComponent(match[1]),
      screenKey: match[2] ? decodeURIComponent(match[2]) : null,
    };
  } catch {
    return null;
  }
};
